import React from 'react'
import styles from './styles.module.scss'

import {QuestionsSpreadByTopics as widget1} from './component/questionsSpreadByTopics/QuestionsSpreadByTopics';


export const QuestionsSpreadByTopics = widget1;

import { PerformanceByQuestion as widget3 } from './component/PerformaneByQuestion/PerformanceByQuestion';

export const PerformanceByQuestion = widget3;

import { QuestionAnalysis as widget2} from './component/QuesitionAnalysis/QuestionAnalysis';

export const QuestionAnalysis = widget2;



import {TopicStrengthsAndWeaknesses as widget5} from './component/topicStrengthsAndWeaknesses/TopicStrengthsAndWeaknesses';
export const TopicStrengthsAndWeaknesses = widget5;

import {SkillStrengthsAndWeaknesses as widget6} from './component/skillStrengthsAndWeaknesses/SkillStrengthsAndWeaknesses';
export const SkillStrengthsAndWeaknesses = widget6;

import { EdwTable as widget7 } from './component/common/edwTable/EdwTable';
export const EdwTable = widget7;

import { GradeAnalysis as widget8} from './component/GradeAnalysis/GradeAnalysis';
export const GradeAnalysis = widget8;

import { GradeSummary as widget9} from './component/GradeSummary/GradeSummary';
export const GradeSummary = widget9;

import { StudentsBelowTarget as widget10} from './component/studentsBelowTarget/StudentsBelowTarget';
export const StudentsBelowTarget = widget10;

import { SkillObjectivesStrengthsAndWeaknesses as widget11} from './component/skillObjectivesStrengthsAndWeaknesses/SkillObjectivesStrengthsAndWeaknesses';
export const SkillObjectivesStrengthsAndWeaknesses = widget11;

import { StudentAssessment as widget12 } from './component/studentAssessments/StudentAssessment';
export const StudentAssessment = widget12;


import { EdwLoader as widget13 } from './component/common/edwLoader/EdwLoader';
export const EdwLoader = widget13;

import {EdwLoaderWithContainer as widget14} from './component/common/edwLoaderWithContainer/EdwLoaderWithContainer';
export const EdwLoaderWithContainer = widget14;

// import { EdwTimeSeries as widget14 } from './component/charts/timeSeries';
// export const EdwTimeSeries = widget14;
 
import {StudentQuestionAnalysis as widget15} from './component/studentQuestionAnalysis/StudentQuestionAnalysis';
export const StudentQuestionAnalysis = widget15;

import { StudentAssessmentInfo as widget16 } from './component/studentAssessmentInfo/StudentAssessmentInfo';
export const StudentAssessmentInfo = widget16;

import { EDWDropDown as widget17 } from './component/common/dropDown/DropDown';
export const EDWDropDown = widget17;

import { AssessmentNoData as widget18} from './component/common/noData/NoData';
export const AssessmentNoData = widget18;

import { BaselineTargetNoData as widget19 } from './component/common/noData/NoData';
export const BaselineTargetNoData = widget19;

import { QuestionNoData as widget20} from './component/common/noData/NoData';
export const QuestionNoData = widget20;

import { GroupAssessment as widget21 } from './component/groupAssessments/GroupAssessment';
export const GroupAssessment = widget21;

import { GroupsByCourses as widget22 } from './component/groupsByCourses/GroupsByCourses';
export const GroupsByCourses = widget22;StudentsNeedAttention

import { StudentsNeedAttention as widget23 } from './component/studentsNeedAttention/StudentsNeedAttention';
export const StudentsNeedAttention = widget23;

import { ErrorMessage as widget24 } from './component/common/messaging/ErrorMessage';
export const ErrorMessage = widget24;

import { RecentAssessments as widget25 } from './component/recentAssessments/RecentAssessments';
export const RecentAssessments = widget25;

import { GroupsTarget as widget26 } from './component/groupsTarget/GroupsTarget';
export const GroupsTarget = widget26;

import { ErrorData as widget27 } from './component/common/noData/NoData';
export const ErrorData = widget27;

import { GroupComparison as widget28 } from './component/groupComparison/GroupComparison';
export const GroupComparison = widget28;

import { CourseTargetAndProgress as widget29 } from './component/courseTargetAndProgress/CourseTargetAndProgress';
export const CourseTargetAndProgress = widget29;

import {EdwTooltip as widget30} from './component/common/ToolTip/EdwTooltip'
export const EdwTooltip = widget30;


import { EdwExportButton as widget31 } from './component/common/dropDown/ExportButton'
export const EdwExportButton = widget31;